/**
 * @file ログアウトボタン付きユーザー情報表示。ログアウト時はSigV4署名付きGETでサーバー側セッション破棄→
 *        sessionStorage/Recoil State清掃→ログアウト画面へ遷移。
 */
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import axios from 'axios';
import { useRouter } from 'next/router';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import useSetLoading from '@/hooks/useSetLoading';
import { loginInfoState } from '@/states/loginInfoState';
import { userState } from '@/states/selectors/userState';

const UserLogout = () => {
  const user = useRecoilValue(userState);
  const resetLoginInfo = useResetRecoilState(loginInfoState);
  const { startLoading, finishLoading } = useSetLoading();
  const router = useRouter();

  // ログアウトフロー: API呼出し → クリーンアップ → リダイレクト
  const handleClickLogOutButton = async (): Promise<void> => {
    startLoading(ApiUrl.Authn.LOGOUT);
    // SigV4署名付きGETでサーバー側セッションを破棄
    const headers = await getSigV4HeadersForGet(ApiUrl.Authn.LOGOUT);
    await axios
      .get(`${process.env.NEXT_PUBLIC_AUTH_URL}${ApiUrl.Authn.LOGOUT}`, headers)
      .finally(() => {
        // APIの成否に関わらずクライアント側のセッションを必ず清掃し、ログアウト画面へ遷移
        resetLoginInfo();
        finishLoading(ApiUrl.Authn.LOGOUT);
        sessionStorage.clear();
        router.replace('/logout');
        // window.location.href = url('/logout');
      });
  };

  return (
    <div className='user'>
      {`ようこそ：${user.name} さま`}
      <button onClick={handleClickLogOutButton} className='button-logout button'>
        ログアウト
      </button>
    </div>
  );
};

export default UserLogout;
